import { Axios_Post } from "../../axios";

export const getFileUploads = (params = {}): Promise<any> => {
  return Axios_Post('/v1/fileUploadsConsole', params)
}
